import { InjectionToken } from "@angular/core";
import { Resolve } from "@angular/router";
import { IWidget } from "../../../../models/application/i-widget";
import { IPage } from "@zaeper/communication-lib";

export const widgetPageResolverInjectionToken: InjectionToken<Resolve<IPage<IWidget>>> = new InjectionToken<Resolve<IPage<IWidget>>>("digital-signage-developer-dashboard.WidgetPageResolver");
